import { environment } from './../../environments/environment';
import { LoggerService } from '../core/logger.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from './api.service';
import { AuthService } from '../auth/services/auth.service';
import { SyncCryptService } from './crypt/sync-crypt.service';
import { ResetpasswordpubkeyApiOutput } from '../shared/models/api/resetpasswordpubkey-api.model';

@Injectable()
export class ResetPasswordService {
    private path = environment.multiadminhost;
    private bCrypt: bCrypt;

    constructor(
        private httpClient: HttpClient,
        private log: LoggerService,
        private api: ApiService,
        private auth: AuthService,
        private crypt: SyncCryptService
    ) {
        this.bCrypt = new bCrypt();
    }

    async verifyEmailInvite(confirmcode): Promise<any> {
        const url = `${this.path}users/invite/${confirmcode}`;

        try {
            //api call to multiadmin server, getting user invite details
            const result = await this.httpClient.get<any>(url).toPromise();
            this.log.info(`${url}: successful`);
            return Promise.resolve(result);
        } catch (err) {
            this.handleError(err as HttpErrorResponse);
        }
    }

    async resetPasswordSubmit(confirmCode, password): Promise<any> {
        const hashPass = await this.auth.hashPassword(
            this.bCrypt.gensalt(8),
            password
        );
        const pubkey = await this.api.fetchText('/key/password-recover/pubkey');
        const passResetKeys = await this.crypt.prepareResetPasswords(
            password,
            pubkey
        );
        const pubkeyOut = await this.api.send<ResetpasswordpubkeyApiOutput>(
            'resetpasswordpubkey',
            {
                cachekey: confirmCode,
            }
        );
        const encPassword = await this.crypt.userpasswordEncrypt(
            password,
            pubkeyOut.pub_key
        );
        const url = `${this.path}users/setpassword`;

        try {
            //api call to multiadmin server, resetting password for user
            const result = await this.httpClient
                .post<any>(url, {
                    enc_pass_meta: passResetKeys.encPassMeta,
                    salt_meta: passResetKeys.metaSalt,
                    enc_pass_priv: passResetKeys.encPassPriv,
                    salt_priv: passResetKeys.privSalt,
                    password_hash: hashPass,
                    enc_password: encPassword,
                    cachekey: confirmCode,
                })
                .toPromise();
            this.log.info(`${url}: successful`);
            return Promise.resolve(result);
        } catch (err) {
            this.handleError(err as HttpErrorResponse);
        }
    }

    private handleError(response: HttpErrorResponse) {
        if (response.status) {
            switch (response.status) {
                case 422:
                    this.log.error(
                        `error status ${response.status}: ${
                            response.error.message
                        }, detail: ${JSON.stringify(
                            response.error.detail,
                            null,
                            4
                        )}`
                    );
                    break;
                case 429:
                    this.log.error(
                        `error status ${response.status}: ${response.error.message}`
                    );
                    break;
                default:
                    this.log.error(
                        `error status ${response.status}: ${
                            response.error.message
                        }\n detail:${JSON.stringify(
                            response.error.detail,
                            null,
                            4
                        )}`
                    );
            }
        } else {
            this.log.error(JSON.stringify(response));
        }
        throw response;
    }
}
